export default __webpack_public_path__ + "e23d0371bde59debbdfd79b7ac0b06ba.png";